<template>
  <ak-empty-state
    title="There isn't anything here yet."
    icon="form"
    class="pt-large"
  >
    <ak-button
      color="primary"
      class="pt-small"
      tag="router-link"
      :to="newAppLink"
      >Create {{ createLabel }}</ak-button
    >
  </ak-empty-state>
</template>

<script>
import EmptyState from '@akerolabs/akero-vue/src/components/emptyState/EmptyState.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AkAppsListEmptyState',

  components: {
    [EmptyState.name]: EmptyState,
    [Button.name]: Button,
  },

  props: {
    newAppLink: {
      type: Function,
      default: () => {},
    },

    createLabel: {
      type: String,
      default: undefined,
    },
  },
})
</script>
